import { useState } from "react";

import { Popover } from "antd";

import { ThreeDViewerOptionT } from "models";

import { ToolbarButton } from "components/base";
import { Icon_ThreeDVVolume } from "components/icons";

import ThreeDVGeoValueOptions from "./ThreeDVGeoValueOptions";

function ThreeDVWellVolumeToggle(options: ThreeDViewerOptionT) {
  const [visible, setVisible] = useState(false);

  return (
    <Popover
      // Named so the guided walkthrough can wait for these options to open.
      overlayClassName="threed-volume-options"
      content={<ThreeDVGeoValueOptions {...options} />}
      trigger="click"
      placement="bottomRight"
      open={visible}
      onOpenChange={(v) => setVisible(v)}>
      <ToolbarButton
        icon={<Icon_ThreeDVVolume />}
        isMenuButton={true}
        active={options.showDrainage}
        tooltipText={"Show Well Volume"}
        data-testid="threed-well-volume-toggle"
        overflowLabel={"Volume"}
        styleKey="threeDVToolbar"
      />
    </Popover>
  );
}

export default ThreeDVWellVolumeToggle;
